<template>
  <div class="container">
    <div class="card-content">
      <div class="content">
        <h1 class="is-5 centered">
          ¡Saludos!
        </h1>
        <p class="detail centered">
          Ponte en contacto con recepción en el
          <a
            target="__blank"
            href="wa.me/+50660188032"
          >
            <span class="icon whatsapp"></span>
            <span class="text"> siguiente enlace</span>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NoForm',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 20px;
  height: 100%;
}
.centered {
  margin-top: 20px;
  text-align: center;
}
</style>

